module.exports = __webpack_public_path__ + "static/img/btn_04.e1c2729.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sv/sv001/btn_04.jpg
// module id = +I4u
// module chunks = 0